import { isPlatformBrowser } from "@angular/common";
import { Inject, Injectable, PLATFORM_ID } from "@angular/core";
import { Resolve, Router } from "@angular/router";
import { of } from "rxjs";
import { catchError } from "rxjs/operators";
import { ApiService } from "src/app/services/api.service";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class StoresListingDataService implements Resolve<any> {
  isBrowser: boolean = false;

  constructor(
    private API: ApiService,
    private router: Router,
    @Inject(PLATFORM_ID) platformId: string
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  resolve() {
    if (this.isBrowser) {
      return this.API.GET(
        `${environment.cdn_url}storeLists/${environment.mall_id}.json`
      ).pipe(
        catchError((error) => {
          this.router.navigate(["/"]);
          return of(null);
        })
      );
    } else {
      return true;
    }
  }
}
